import React from 'react';
import PropTypes from 'prop-types';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { isEmpty, take, toLower, camelCase } from 'lodash';
import { formatDateTime, transformFeedback, STICKY_HEIGHT } from '../../utils/Formatters';
import { MSG_NO_PLAYS } from '../../utils/messages';

const SUMMARY_SIZE = 3;

export default class AccountPlayerPlaysSummary extends React.Component {
  static propTypes = {
    plays: PropTypes.arrayOf(PropTypes.object).isRequired,
    tabIdx: PropTypes.number.isRequired,
    onClickMore: PropTypes.func,
  }

  onClickMore = (e) => {
    e.preventDefault();
    this.props.onClickMore(0, '#plays');
  }

  render() {
    const { plays, tabIdx } = this.props;
    const rows = take(plays, SUMMARY_SIZE).map(data => {
      const key = toLower(camelCase(data.feedbackLiked));
      return (
        <li key={data.id} className='u-margin-bottom--tiny'>
          <span className='u-txt--label'>Date: </span>{formatDateTime(data.createdAt)}<br />
          <span className='u-txt--label'>Card: </span>{data.cardTitle}<br />
          <span className='u-txt--label'>Feedback: </span>
          { isEmpty(data.feedbackLevel) && 'None' }
          { !isEmpty(data.feedbackLevel) && transformFeedback(data.feedbackLevel) }
          { !isEmpty(data.feedbackLiked) && <i className={`sp-icon-feedback-${key} cs-txt--sp-feedback-${key} fa-lg u-margin-left--small`}></i> }
        </li>
      );
    });
    return (
      <div className='o-card__wrap'>
        <b>Recent Plays History</b>
        <section className='column o-card cs-bg--light'>
          { isEmpty(rows) && <p className='u-margin-bottom--zero'>{MSG_NO_PLAYS}</p> }
          <ul className='no-bullet u-margin-bottom--zero'>
            { rows }
          </ul>
          { plays.length > SUMMARY_SIZE ? (tabIdx !== 0 ?
            <a className='cs-txt-link--sp-blue u-margin-top--base' onClick={this.onClickMore}>
              Show More
            </a> :
            <AnchorLink className='cs-txt-link--sp-blue u-margin-top--base' href='#plays' offset={STICKY_HEIGHT}>
              Show More
            </AnchorLink>) : null }
        </section>
      </div>
    );
  }
}
